export default __webpack_public_path__ + "static/media/soccer-kids.21fac118.jpg";